import type { ICommand } from './ICommand';
import { useDiagramStore } from '../../stores/diagramStore';

export class SetSelectionCommand implements ICommand {
  id: string;
  name = 'Set selection';
  timestamp: number;
  private readonly previousSelection: Set<string>;
  private readonly nextSelection: Set<string>;

  constructor(nextSelection: Set<string>, previousSelection: Set<string>) {
    this.id = `set-selection-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    this.timestamp = Date.now();
    this.nextSelection = new Set(nextSelection);
    this.previousSelection = new Set(previousSelection);
  }

  execute(): void {
    useDiagramStore.getState().setSelected(this.nextSelection);
  }

  undo(): void {
    useDiagramStore.getState().setSelected(this.previousSelection);
  }

  redo(): void {
    useDiagramStore.getState().setSelected(this.nextSelection);
  }
}
